import { render, staticRenderFns } from "./Grid23.vue?vue&type=template&id=9f4129aa&scoped=true"
import script from "./Grid23.vue?vue&type=script&lang=ts"
export * from "./Grid23.vue?vue&type=script&lang=ts"
import style0 from "./Grid23.vue?vue&type=style&index=0&id=9f4129aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4129aa",
  null
  
)

export default component.exports